function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeshopBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.33,145.29s-80.4-115.75-180.78-128C176.94,6.41,94.69,48.79,83.24,140.35,79.16,173,71.9,209.07,59,238.83,44.53,272.21,19.84,300,38.75,364.17,52.26,410,96.83,452.63,142.35,473.22H247c38.68-18.62,74.75-54.45,106.17-88C398.12,337.27,541.4,292.17,446.33,145.29Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.33,145.29s-80.4-115.75-180.78-128C176.94,6.41,94.69,48.79,83.24,140.35,79.16,173,71.9,209.07,59,238.83,44.53,272.21,19.84,300,38.75,364.17,52.26,410,96.83,452.63,142.35,473.22H247c38.68-18.62,74.75-54.45,106.17-88C398.12,337.27,541.4,292.17,446.33,145.29Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelves-2--inject-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.48,
    y: 156.11,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.22,
    y: 156.11,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.95,
    y: 156.11,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.48,
    y: 156.11,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.22,
    y: 156.11,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.95,
    y: 156.11,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.6,
    y: 228.98,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.34,
    y: 228.98,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.07,
    y: 228.98,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.6,
    y: 228.98,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.34,
    y: 228.98,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.07,
    y: 228.98,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.82,
    y: 156.11,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.56,
    y: 156.11,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.29,
    y: 156.11,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.82,
    y: 156.11,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.56,
    y: 156.11,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.29,
    y: 156.11,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.69,
    y: 156.11,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.43,
    y: 156.11,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.16,
    y: 156.11,
    width: 16.98,
    height: 19.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.69,
    y: 156.11,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.43,
    y: 156.11,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.16,
    y: 156.11,
    width: 16.98,
    height: 7.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.28 209.66 425.28 193.34 418.82 193.34 418.82 209.66 413.47 217.84 413.47 250.21 430.63 250.21 430.63 217.84 425.28 209.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.82,
    y: 193.34,
    width: 6.45,
    height: 8.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.47,
    y: 226.03,
    width: 13.26,
    height: 13.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.05 209.66 403.05 193.34 396.6 193.34 396.6 209.66 391.25 217.84 391.25 250.21 408.4 250.21 408.4 217.84 403.05 209.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 193.34,
    width: 6.45,
    height: 8.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.25,
    y: 226.03,
    width: 13.26,
    height: 13.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.81 209.66 243.81 193.34 237.36 193.34 237.36 209.66 232.01 217.84 232.01 250.21 249.17 250.21 249.17 217.84 243.81 209.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.36,
    y: 193.34,
    width: 6.45,
    height: 8.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.01,
    y: 226.03,
    width: 13.26,
    height: 13.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.15,
    y1: 176.61,
    x2: 441.03,
    y2: 176.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.45,
    y1: 104.56,
    x2: 294.45,
    y2: 250.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370.19,
    y1: 104.56,
    x2: 370.19,
    y2: 250.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.83,
    y: 102.65,
    width: 220.74,
    height: 148.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelves-1--inject-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.47,
    y: 190.84,
    width: 132.88,
    height: 99.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.47,
    y: 221.79,
    width: 132.88,
    height: 4.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.92,251.25s6.9-8.76,17-8.23,12,8.5,12,8.5H56.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68,252.31S70.54,243,76.91,243",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,251.78s.8-7.16,6.38-6.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,251.25s6.9-8.76,17-8.23,12,8.5,12,8.5H102.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,252.31s1.85-9.29,8.22-9.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.43,251.78s.79-7.16,6.37-6.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.77,251.25s6.9-8.76,17-8.23,11.94,8.5,11.94,8.5H148.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.53,252.31s1.86-9.29,8.23-9.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.35,251.78s.8-7.16,6.37-6.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.47,
    y: 251.53,
    width: 132.88,
    height: 4.53,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.47,
    y: 190.84,
    width: 132.88,
    height: 4.51,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.47,
    y: 277.02,
    width: 132.88,
    height: 13.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.78,
    y: 206.12,
    width: 18.05,
    height: 15.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.78,
    y: 206.12,
    width: 18.05,
    height: 2.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.02,
    y: 206.12,
    width: 55.48,
    height: 15.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.02,
    y: 206.12,
    width: 55.48,
    height: 2.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.77,
    y: 206.12,
    width: 15.13,
    height: 15.93,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.77,
    y: 206.12,
    width: 15.13,
    height: 2.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329,360.17l14.22,95.91-1.83,2.75v4.82s-9,8-9.18,9a8.58,8.58,0,0,0,0,2.52h26.39s0-3.67-.23-5.74-.92-1.6-.69-4.13,1.38-6.88,1.15-9.17-1.61-2.3-1.84-6.2-3-90.4-3-90.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.12,360.17l-14.23,95.91,1.84,2.75v4.82s8.94,8,9.17,9a8.58,8.58,0,0,1,0,2.52H354.52s0-3.67.23-5.74.91-1.6.69-4.13-1.38-6.88-1.15-9.17,1.6-2.3,1.83-6.2,3-90.4,3-90.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.73,263.63,400.88,288s-3.33,2.8-6.48,1.23-8.24-7.36-8.59-8.24S384.23,265,384.23,265Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.73,263.63l-13.5,1.4s.2,2.39.46,5.32H398.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.67,263.28l-2.1,23.65s-.7,7.88-.7,11.56.08,35.82.08,35.82-1.23,8.76-.35,10,4.55,6.13,4.55,6.13,3.68,1.05,4.21,1.23,2.1-2.1,1.22-2.46a20.18,20.18,0,0,0-2.62-.7l-2.81-5.78,2.11-5.61s1.57,7.19,1.57,7.89.88,2.28,1.4.17-.17-3.85.35-6.48S321.06,334,320,332s-1.58-2.8-1.58-2.8,6.41-36,6.93-37.57S328,263.45,328,263.45Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.05,270.35h13.38c.33-4,.56-6.9.56-6.9l-13.32-.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.93,266.09l21.34-1.38s-8.72-32.58-8.72-33.49-26.16-20.88-26.16-20.88l-1.61-.23L356.16,212l-12.62-1.91-1.6.23s-26.16,20-26.16,20.88-8.72,33.49-8.72,33.49l21.34,1.38-1.83,25s-2.76,16.75-1.84,27.08-.29,45.66-.29,45.66h63.44s-.28-36.26-.28-45.66c0-10.37-2.3-27.08-2.3-27.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.27,215.84l-.95-1-1.92-1.48,4.71,24H333.68l3.9-23.17-2.52,1.83s-5.51,20-5.74,22.49-.92,27.53-.92,27.53l-1.83,25s-2.76,16.75-1.84,27.08-.29,45.66-.29,45.66h63.44s-.28-36.26-.28-45.66c0-10.37-2.3-27.08-2.3-27.08l-1.37-25,.92-25.7Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.71,201a10.26,10.26,0,0,0-2.92,4.88c-1,3.32-4.29,22-2.93,21.85s10.73-6.44,11.71-7,7.21,4.68,7.21,4.68,5.47-5.07,6.83-5.46,11.51,7,11.71,5.27-5.85-20.29-8.2-23-8.19-2.93-8.19-2.93S350.35,196.51,343.71,201Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.15,195.14s2.34,14.63,2.73,16.39,11.12,14.05,11.9,13.85,7.61-15.8,7.81-16.78S365.76,195,365.76,195Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.28,195l-16.13.13s1.71,10.64,2.45,14.86l10.65-4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.86,179.34s-4.29-2.15-4.29,2.93a10.63,10.63,0,0,0,4.49,8.38C338.64,191.05,337.86,179.34,337.86,179.34Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,179.34s4.29-2.15,4.29,2.93a10.66,10.66,0,0,1-4.48,8.38C366.17,191.05,367,179.34,367,179.34Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.32,155.15s-9,6.24-8.58,10.92,3.32,26.54,4.49,28.29,10.34,12.68,11.51,12.88,7.64.46,8-.32,8.75-11.19,9.14-13.73.78-27.7,0-30.24S359.91,148.12,343.32,155.15Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.32,155.15s-9,6.24-8.58,10.92c.23,2.71,1.3,11.16,2.39,18.15.72-1.18,2.78-4.83,2.29-7.42a76.13,76.13,0,0,1-.58-9.75,48.32,48.32,0,0,0,11.9,2.34c6.44.39,14.43-2.73,14.43-2.73s-.39,9.56.39,10.73c.58.87,2,3.9,2.73,5.39.13-8.15.1-18.27-.38-19.83C367.12,160.42,359.91,148.12,343.32,155.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.35,194.56s3.31,1.17,4.87.78a9.9,9.9,0,0,0,2.93-1.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.59,196.9a9,9,0,0,0,5.46,1.75,18.78,18.78,0,0,0,6.44-2.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.71,185.78a6.84,6.84,0,0,0,6.44.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.15,186s3.71.78,5.85-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.35,182.66s-3.91-1.37-6.64.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,183.05s3.51-2.15,6-.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.26,277.29s7.19,2.81,10.34,5.61,2.46,8.41,1,11-7.18,3.85-9.11,3.33-3.82-4.1-5.24-6.17-5.62-11.53-5.62-11.53Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.93,274a14,14,0,0,1-3.68,1.06c-1.75.17-5.26-1.23-5.43.52s2.27,3.15,3.85,3.51a18.54,18.54,0,0,0,4.56,0,69.4,69.4,0,0,0,6.48,5.6c1.93,1.23,7.18-.17,7-2.63s-4.21-5.95-6.31-7S377.93,274,377.93,274Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.8,269.93s-2.45,8.06-1.57,9.12,1.75,1.05,2.45.52,3.15-5.61,3.68-7.53S380.91,266.78,378.8,269.93Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.36,272s3.33.7,3.5,2.27-2.8,6.14-4.55,7.19-2.63-1.93-2.63-1.93Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.86,274.31s2.81,1.58,2.81,3.16-2.81,4.38-4.38,5.25-3-1.22-3-1.22Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.67,277.47s1.75,3.85,1.05,4.55-4.56,3.16-5.43,2.81,0-2.11,0-2.11S389,279.05,389.67,277.47Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.07,285.72H216a8.5,8.5,0,0,1-5.86-3.13,5,5,0,0,1-.91-3.93,3.14,3.14,0,0,1,1.67-2.46,4.35,4.35,0,0,1,3.61.38.92.92,0,0,1-.9,1.61h0a2.66,2.66,0,0,0-1.93-.31A1.46,1.46,0,0,0,211,279a3.13,3.13,0,0,0,.58,2.5,6.86,6.86,0,0,0,4.6,2.39.92.92,0,0,1-.11,1.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,287.58h0a5.56,5.56,0,0,1-5.53-5L213.7,275h12.57l-.75,7.57A5.57,5.57,0,0,1,220,287.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.75 287.48 207.04 287.48 209.27 289.33 231.53 289.33 233.75 287.48",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.7,273.35s.66-3,2.38-4.35,4-2.12,4-3.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.45,273.35s-.53-1.71,2-2.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Counter--inject-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.15,
    y: 250,
    width: 56.64,
    height: 39.46,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.01,
    y: 255.29,
    width: 50.9,
    height: 34.17,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.19,
    y: 272.37,
    width: 16.55,
    height: 17.08,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.01 255.29 350.15 250 406.78 250 403.91 255.29 353.01 255.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.32,
    y: 289.48,
    width: 420.97,
    height: 185.64,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.32,
    y: 289.48,
    width: 420.97,
    height: 14.77,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.32,
    y: 289.48,
    width: 420.97,
    height: 9.44,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,378.76c1.77.77,6.12.67,6.12.67s-.93-2.84-1-3c-.95-2-4-5.29-6.42-5a2.93,2.93,0,0,0-2.35,3.67C15.75,376.83,17.49,378.09,19,378.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.51,391.34c1.84.27,5.72-.85,6-.94a51.87,51.87,0,0,0,2.36,6.5c.53,1.24,1.11,2.47,1.7,3.69-.36-.52-.68-1-.73-1-1.44-1.67-5.22-4.05-7.5-3.08a2.93,2.93,0,0,0-1.3,4.16c.84,1.53,2.86,2.29,4.49,2.53s5-.65,5.86-.9c.24.46.46.93.7,1.4,1.12,2.24,2.25,4.46,3.29,6.68.37.78.7,1.56,1,2.35l-.63-.9c-1.45-1.67-5.23-4.05-7.5-3.09a2.93,2.93,0,0,0-1.3,4.17c.84,1.53,2.85,2.28,4.49,2.52s4.66-.56,5.7-.85c.32.81.64,1.62.92,2.42.17.55.38,1.07.52,1.63s.31,1.11.46,1.65c.25,1.06.52,2.15.74,3.19.16.72.3,1.41.44,2.1-.35-.78-1.08-2.3-1.16-2.42-1.17-1.87-4.55-4.79-6.95-4.18a2.93,2.93,0,0,0-1.91,3.92c.6,1.64,2.48,2.69,4.06,3.17s5.58.05,6.06,0c.23,1.15.45,2.27.63,3.33.42,2.34.73,4.44,1,6.21H43.6c-.29-1.83-.66-4-1.15-6.48-.23-1.17-.49-2.41-.78-3.69a30.9,30.9,0,0,0,3.38-1.59A21.42,21.42,0,0,0,50,427c-.44,1.09-.88,2.14-1.32,3.13-.89,2.06-1.75,3.9-2.5,5.45h1.76c.64-1.43,1.35-3.07,2.1-4.88.45-1.1.91-2.29,1.38-3.51.46.1,4.27.87,6.05.47,1.61-.37,3.56-1.28,4.28-2.87a2.93,2.93,0,0,0-1.62-4.05c-2.34-.79-5.93,1.88-7.24,3.66-.08.1-.79,1.33-1.23,2.12.19-.5.38-1,.56-1.5.38-1,.72-2.05,1.09-3.16.17-.54.33-1.09.5-1.64s.29-1.14.44-1.71c.32-1.34.57-2.72.8-4.11.9.33,4.09,1.44,5.75,1.32s3.71-.72,4.66-2.18a2.93,2.93,0,0,0-1-4.25c-2.2-1.13-6.15,1-7.71,2.52-.1.1-1.1,1.34-1.63,2,.13-.84.26-1.67.37-2.52.3-2.46.53-4.95.78-7.44.07-.76.15-1.52.23-2.28.32.12,4.09,1.52,5.94,1.39,1.65-.11,3.71-.72,4.67-2.18a2.93,2.93,0,0,0-1-4.25c-2.2-1.14-6.14,1-7.71,2.52-.12.11-1.55,1.91-1.89,2.38.17-1.67.37-3.34.62-5a51.89,51.89,0,0,1,1.43-6.54c.15.06,4.07,1.54,6,1.41,1.65-.12,3.71-.72,4.67-2.19a2.93,2.93,0,0,0-1-4.25c-2.2-1.13-6.14,1-7.71,2.52-.12.12-1.66,2.05-1.92,2.42,0-.12.06-.25.1-.38a38,38,0,0,1,2.59-6.18c.56-1.1,1.16-2.13,1.77-3.11.7.35,3.93,1.92,5.65,2s3.77-.31,4.88-1.66a2.92,2.92,0,0,0-.51-4.33c-2.06-1.37-6.21.28-7.94,1.66-.1.07-1,.94-1.59,1.58.28-.44.56-.9.84-1.31,1-1.56,2.08-2.93,3-4.13.54-.67,1-1.28,1.51-1.84.87,0,4.37-.12,5.9-.84s3.21-2,3.57-3.72A2.94,2.94,0,0,0,75.93,364c-2.46-.26-5.39,3.11-6.29,5.13-.07.18-1,3.05-.93,3.05h.05c-.47.52-1,1.1-1.48,1.73-1,1.19-2,2.53-3.12,4.07a54.68,54.68,0,0,0-3.23,5.15,37.85,37.85,0,0,0-2.75,6.21l0,.07c0-.72,0-2.75,0-2.91-.28-2.19-2.12-6.26-4.55-6.71a2.93,2.93,0,0,0-3.38,2.76c-.14,1.74,1.12,3.48,2.35,4.58,1.39,1.24,5.24,2.44,5.55,2.54a51.5,51.5,0,0,0-1.63,6.72c-.23,1.33-.43,2.67-.61,4,0-.63,0-1.19,0-1.27-.29-2.19-2.12-6.26-4.56-6.71a2.94,2.94,0,0,0-3.38,2.76c-.14,1.74,1.12,3.48,2.35,4.58s4.52,2.21,5.39,2.48c-.07.52-.14,1-.2,1.56-.29,2.48-.58,5-.93,7.39-.13.85-.28,1.69-.43,2.52,0-.55,0-1,0-1.09-.29-2.2-2.13-6.26-4.56-6.71a2.93,2.93,0,0,0-3.38,2.75c-.14,1.74,1.12,3.49,2.35,4.59s4.2,2.09,5.23,2.43c-.18.85-.36,1.71-.57,2.53-.16.55-.28,1.1-.47,1.65s-.35,1.09-.52,1.62c-.37,1-.75,2.08-1.14,3.07-.26.69-.53,1.34-.79,2,.13-.85.36-2.52.36-2.66A11.37,11.37,0,0,0,49,418.33a4.73,4.73,0,0,0,0-.65,2.93,2.93,0,0,0-3.59-2.48c-2.39.63-3.91,4.83-4,7,0,.13.08,1.55.15,2.45-.12-.52-.23-1-.36-1.56-.26-1.06-.54-2.11-.84-3.24-.16-.54-.32-1.09-.49-1.64s-.39-1.11-.58-1.67c-.47-1.29-1-2.58-1.59-3.87.93-.22,4.2-1.06,5.52-2.07s2.7-2.65,2.69-4.39a2.94,2.94,0,0,0-3.17-3c-2.46.26-4.6,4.19-5,6.35,0,.14-.18,1.73-.24,2.6-.35-.77-.7-1.54-1.08-2.31-1.1-2.21-2.28-4.42-3.45-6.63l-1.06-2c.33-.08,4.25-1,5.72-2.12,1.31-1,2.7-2.65,2.69-4.39a2.93,2.93,0,0,0-3.17-3c-2.46.27-4.6,4.19-5,6.35,0,.16-.24,2.45-.27,3-.77-1.5-1.53-3-2.22-4.49a51.62,51.62,0,0,1-2.41-6.24c.15,0,4.24-1,5.75-2.13,1.31-1,2.7-2.65,2.69-4.4a2.92,2.92,0,0,0-3.17-3c-2.46.26-4.59,4.18-5,6.35,0,.17-.26,2.63-.26,3.08,0-.12-.1-.25-.13-.37a37.54,37.54,0,0,1-1.25-6.59c-.14-1.23-.21-2.41-.24-3.57.78-.09,4.34-.57,5.81-1.46s3-2.33,3.16-4.07a2.93,2.93,0,0,0-2.82-3.33c-2.48,0-5,3.66-5.71,5.76,0,.11-.29,1.32-.45,2.2,0-.52,0-1.06,0-1.56,0-1.87.12-3.58.24-5.1.07-.86.16-1.64.24-2.37.72-.49,3.58-2.51,4.46-4s1.57-3.44.92-5.07a2.93,2.93,0,0,0-4-1.66c-2.2,1.14-2.78,5.57-2.41,7.75,0,.19.86,3.08.9,3.05l0,0c-.1.7-.19,1.45-.28,2.27-.15,1.52-.31,3.24-.35,5.12a52.61,52.61,0,0,0,.14,6.07,39.42,39.42,0,0,0,1.13,6.7.19.19,0,0,1,0,.07c-.39-.61-1.53-2.28-1.64-2.4-1.44-1.67-5.22-4.05-7.5-3.09a2.94,2.94,0,0,0-1.3,4.17C16.86,390.35,18.87,391.1,20.51,391.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,379.71s.79-2.89.82-3.08c.3-2.18-.4-6.59-2.63-7.67a2.92,2.92,0,0,0-4,1.76c-.6,1.65.16,3.66,1,5C59.28,377.39,63,379.71,63,379.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.14 432.47 31.46 432.47 34.13 475.12 55.47 475.12 58.14 432.47",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stool--inject-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.56,
    y: 356.28,
    width: 5.37,
    height: 118.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.85,
    y: 401.55,
    width: 33.68,
    height: 2.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.24,
    y: 440.83,
    width: 38.9,
    height: 2.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.3 475.12 258.56 475.12 268.54 354.95 274.27 354.95 264.3 475.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.09 475.12 310.82 475.12 300.85 354.95 295.11 354.95 305.09 475.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.71,
    y: 347.63,
    width: 39.06,
    height: 10.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.71,
    y: 347.63,
    width: 39.06,
    height: 4.95,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.67,
    y: 345.63,
    width: 45.15,
    height: 4.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Poster--inject-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.33,
    y: 40.06,
    width: 106.35,
    height: 142.7,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.44,
    y1: 76.41,
    x2: 116.92,
    y2: 76.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.44,
    y1: 92.56,
    x2: 116.92,
    y2: 92.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.44,
    y1: 108.72,
    x2: 116.92,
    y2: 108.72,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.44,
    y1: 124.88,
    x2: 116.92,
    y2: 124.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.44,
    y1: 141.03,
    x2: 116.92,
    y2: 141.03,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.44,
    y1: 157.19,
    x2: 116.92,
    y2: 157.19,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.76,
    y1: 76.41,
    x2: 162.24,
    y2: 76.41,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.76,
    y1: 92.56,
    x2: 162.24,
    y2: 92.56,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.76,
    y1: 108.72,
    x2: 162.24,
    y2: 108.72,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.76,
    y1: 124.88,
    x2: 162.24,
    y2: 124.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.76,
    y1: 141.03,
    x2: 162.24,
    y2: 141.03,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.76,
    y1: 157.19,
    x2: 162.24,
    y2: 157.19,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.55,66.34a4.75,4.75,0,0,1-2.59-.62A3.24,3.24,0,0,1,98.62,64a7.7,7.7,0,0,1-.39-2.56V56.13a7.88,7.88,0,0,1,.39-2.63A3.14,3.14,0,0,1,100,51.79a4.84,4.84,0,0,1,2.59-.6,5,5,0,0,1,2.49.53,2.87,2.87,0,0,1,1.28,1.49,6.21,6.21,0,0,1,.37,2.25v1.23h-2.91V55.31a7.27,7.27,0,0,0-.06-1,1.24,1.24,0,0,0-.3-.73,1.07,1.07,0,0,0-.85-.28,1.15,1.15,0,0,0-.87.29,1.45,1.45,0,0,0-.35.76,6.5,6.5,0,0,0-.07,1v6.71a5,5,0,0,0,.1,1.08,1.25,1.25,0,0,0,.38.71,1.17,1.17,0,0,0,.81.25,1,1,0,0,0,.83-.28,1.35,1.35,0,0,0,.31-.76,6.45,6.45,0,0,0,.07-1V60.69h2.91v1.22a6.75,6.75,0,0,1-.36,2.29,3.09,3.09,0,0,1-1.26,1.57A4.66,4.66,0,0,1,102.55,66.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.71,66.32a4.28,4.28,0,0,1-1.94-.41,2.78,2.78,0,0,1-1.21-1.19,4.26,4.26,0,0,1-.41-1.95V59a4.26,4.26,0,0,1,.41-1.95,2.78,2.78,0,0,1,1.21-1.19,4.77,4.77,0,0,1,3.87,0A2.8,2.8,0,0,1,114.86,57a4.13,4.13,0,0,1,.42,1.95v3.8a4.13,4.13,0,0,1-.42,1.95,2.8,2.8,0,0,1-1.22,1.19A4.26,4.26,0,0,1,111.71,66.32Zm0-1.86a.67.67,0,0,0,.52-.19.93.93,0,0,0,.24-.53,4.38,4.38,0,0,0,.06-.77V58.79a4.42,4.42,0,0,0-.06-.78,1,1,0,0,0-.24-.53.67.67,0,0,0-.52-.2.68.68,0,0,0-.53.2A1,1,0,0,0,111,58a4.42,4.42,0,0,0-.06.78V63a4.38,4.38,0,0,0,.06.77.94.94,0,0,0,.25.53A.67.67,0,0,0,111.73,64.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.38,66.14V57.48h-1.06V55.6h1.06v-.73a6.11,6.11,0,0,1,.19-1.64,1.8,1.8,0,0,1,.77-1.07,3.28,3.28,0,0,1,1.79-.39l.68,0c.22,0,.46,0,.72.07v2a2.21,2.21,0,0,0-.32-.07,1.84,1.84,0,0,0-.33,0,.69.69,0,0,0-.57.23,1.15,1.15,0,0,0-.18.72v.84h1.4v1.88h-1.4v8.66Zm5.16,0V57.48h-1.06V55.6h1.06v-.73a6.11,6.11,0,0,1,.19-1.64,1.8,1.8,0,0,1,.77-1.07,3.28,3.28,0,0,1,1.79-.39l.68,0c.22,0,.46,0,.72.07v2a2.21,2.21,0,0,0-.32-.07,1.84,1.84,0,0,0-.33,0,.69.69,0,0,0-.57.23,1.15,1.15,0,0,0-.18.72v.84h1.4v1.88h-1.4v8.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.16,66.32a4,4,0,0,1-1.95-.43A2.75,2.75,0,0,1,128,64.63a4.61,4.61,0,0,1-.4-2V59.1a4.61,4.61,0,0,1,.4-2,2.74,2.74,0,0,1,1.21-1.24,4,4,0,0,1,1.93-.43,3.76,3.76,0,0,1,2,.44,2.54,2.54,0,0,1,1.1,1.27,5.17,5.17,0,0,1,.36,2V61h-4.23v2a2.31,2.31,0,0,0,.1.75.81.81,0,0,0,.28.41.92.92,0,0,0,.46.11.87.87,0,0,0,.44-.11.71.71,0,0,0,.29-.38,2,2,0,0,0,.09-.67v-1h2.55V63a3.23,3.23,0,0,1-.87,2.44A3.52,3.52,0,0,1,131.16,66.32Zm-.82-6.62H132v-1a2.41,2.41,0,0,0-.09-.73.72.72,0,0,0-.29-.41,1,1,0,0,0-.48-.11.79.79,0,0,0-.45.12.88.88,0,0,0-.26.45,3.46,3.46,0,0,0-.09.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.55,66.32a4,4,0,0,1-2-.43,2.73,2.73,0,0,1-1.18-1.26,4.47,4.47,0,0,1-.4-2V59.1a4.47,4.47,0,0,1,.4-2,2.77,2.77,0,0,1,1.2-1.24,4,4,0,0,1,1.94-.43,3.76,3.76,0,0,1,1.95.44,2.64,2.64,0,0,1,1.1,1.27,5.18,5.18,0,0,1,.35,2V61h-4.22v2a2.31,2.31,0,0,0,.1.75.75.75,0,0,0,.28.41.88.88,0,0,0,.45.11.94.94,0,0,0,.45-.11.7.7,0,0,0,.28-.38,2,2,0,0,0,.09-.67v-1h2.56V63a3.24,3.24,0,0,1-.88,2.44A3.48,3.48,0,0,1,139.55,66.32Zm-.82-6.62h1.65v-1a2.41,2.41,0,0,0-.09-.73.7.7,0,0,0-.28-.41,1,1,0,0,0-.48-.11.77.77,0,0,0-.45.12.82.82,0,0,0-.26.45,3.46,3.46,0,0,0-.09.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.92,
    y: 356.28,
    width: 5.37,
    height: 118.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.22,
    y: 401.55,
    width: 33.68,
    height: 2.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.61,
    y: 440.83,
    width: 38.9,
    height: 2.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.66 475.12 115.93 475.12 125.91 354.95 131.64 354.95 121.66 475.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.46 475.12 168.19 475.12 158.21 354.95 152.48 354.95 162.46 475.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.08,
    y: 347.63,
    width: 39.06,
    height: 10.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.08,
    y: 347.63,
    width: 39.06,
    height: 4.95,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.04,
    y: 345.63,
    width: 45.15,
    height: 4.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,446s-8.16,6.88-7.4,7.9,8.67,12,11.48,14.79,11,6.88,12.49,5.35-4.33-13.26-5.35-15.81a21.19,21.19,0,0,1-.77-8.41C197.21,449,186.5,446,186.5,446Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.58,464.33c-2.86-3.43-7.44-10.14-9.56-13.31-1.27,1.32-2.2,2.49-1.92,2.86.77,1,8.67,12,11.48,14.79s11,6.88,12.49,5.35a1.61,1.61,0,0,0,.24-1.22C199.81,471.17,193.43,467.75,190.58,464.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.71,446.74s-8.16,6.88-7.4,7.9,8.67,12,11.48,14.79,11,6.89,12.49,5.36-4.34-13.26-5.36-15.81a21,21,0,0,1-.76-8.42C169.41,449.8,158.71,446.74,158.71,446.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.79,465.1c-2.87-3.44-7.44-10.15-9.56-13.31-1.28,1.32-2.2,2.48-1.92,2.85.77,1,8.67,12,11.48,14.79s11,6.89,12.49,5.36a1.59,1.59,0,0,0,.23-1.23C172,471.93,165.63,468.52,162.79,465.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89,307s23.44,19.13,23.71,21.29a23.56,23.56,0,0,1-.27,5.39s22.91,43.92,23.72,49.85,6.2,69.53,6.2,69.53l-7-.27,1.35,5.66s-11.59,4.85-24,1.08-31-12.67-31-12.67L167,401.31s-11-.54-11.86-3.23-32.34-62-32.34-62,9.7-31.8,12.13-32.61S161.89,307,161.89,307Z",
    style: {
      fill: "#b5b5b5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.54,364.94c2.66.26,3.86.26,3.86.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.28,348.49s16.44,12.93,27.49,14.82c3.59.61,6.5,1,8.79,1.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.67,345s24,40.42,24.25,41.23,11.32,64.41,11.32,64.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.55,
    y1: 347.41,
    x2: 177.79,
    y2: 340.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1,391.28a17.93,17.93,0,0,0,5.46,1.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.48,366.28s25.34,20.75,30.19,23.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.01,
    y1: 401.31,
    x2: 176.44,
    y2: 410.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.21,436.52a18.67,18.67,0,0,1-8.2,4.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.53,390.8s-11.05,36.65-14,42.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,445.86a34.07,34.07,0,0,1-1.47,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.8,409.66s-2.76,21.9-5.38,34.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.36 281.13 188 283.88 185.11 286.35 182.5 282.78 191.16 274.81 193.36 281.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.14 261.48 182.37 280.99 190.2 280.31 202.84 262.17 195.14 261.48",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,271.51s-5.63-1.37-6.18-.14.41,1.79,1.78,2.48,3.3,1.23,4.26-.28S200.64,271.51,200.64,271.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.89,275s-6.32-1.24-6.73-.14-3.85,5.91-3,6.46,6,1,7-.14S197.89,275,197.89,275Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.86 288.82 182.37 280.99 187.59 287.59 160.25 312.73 159.42 295.28 169.86 288.82",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.38,267.25s2.06,15.94,2.34,22.26.82,21.16.82,21.16l9.9-1.65s-1.24-18.82-3.3-28.58a60.27,60.27,0,0,0-5.91-16.35Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.28,265.05a279.17,279.17,0,0,1,4,34.77c.82,18.13-5.64,40.12-5.64,40.12s-7.14,3.84-23.22-2.61a199.74,199.74,0,0,1-27.06-13.19s1.78-38.34,8-52.63,9.34-20.88,15.66-22.67S159.28,265.05,159.28,265.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,257.91,146,278l-31.77-4.24s-11.65,45.6-11.79,51,7,12.77,21.16,17.17,19.37,7,24,3.16,10.45-51.25,10-56.2-.68-7.14-.68-7.14l-9.07-3.85-3.3-19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,237.85s-7.28,2.75-7.42,6.87,3.44,7.83,4.67,8.38,20.2,10.85,22.26,11.4,10.72-2.74,10.72-5.49-21.3-19.65-23.77-21.71S134,237.85,134,237.85Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,229.88s-5.36-2.2-6.87.27-2.2,6.6-1.1,7.7,14.7,23.08,19.51,26.65,5.91,4.68,8.25,3,5.63-4.4,7.14-8,3.71-4.12.28-8.8-4.13-4.94-4.13-4.94Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.07,230.15s-2.34,5.09-3.3,6.19-2.47,1.1-2.47,2.2.82,5.49-.14,6.18-5.22,1.24-5.22,1.24-3.85,5.77-5.5,6.32-5.77-1.93-8.79-3.71-7.42-8.52-9.76-12.23-2.47-5.91-1.92-6.46-.55-8.11,11.4-10.17,19.38.28,21.44,2.75S179.07,230.15,179.07,230.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.89,238c-.47.8-1.11,1.3-1.43,1.11s-.2-1,.27-1.79,1.11-1.3,1.43-1.11S170.36,237.19,169.89,238Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.72,235.85s-2.24-1.46-4-.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.76,245.94a4.89,4.89,0,0,1-2.58-3.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.78,201.85s-6.46,5.77-7.28,13.88S141,228.51,142,229.88s3.16.82,4.95-.55,4.94-4.67,8-4.53,5.08,0,5.08,0a46.24,46.24,0,0,1-5.5,9.75,30,30,0,0,1-4,4.4s7.83-6.32,10.44-8.38,4.12-6.46,4.12-6.46v3l5.91,2.61,3-4.53-1.23,5.49s1.23.28,2.88.83a36.79,36.79,0,0,0,6.05.82s1.79-8.93,1.79-14.56S175.91,203,167.39,200.2,150.35,198.69,146.78,201.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.78,201.85a20.43,20.43,0,0,0-9.89-4.4c-5.91-.82-10.31,5-11.68,8.66a10,10,0,0,0-.55,6.18l10.58,3.3s1.78-9.89,5.08-11.68a8.74,8.74,0,0,1,5.91-1.1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.2,228.09s-1.37-6.59-5.22-6.18-3.16,11.13-1.79,12,4-.27,4-.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.47,278.93s2.89-4.53,3.3-5.49,2.34-12.51,3.3-13.47,6.59-2.61,8.65-3.3,5.36-1.51,5.5-.82-2.88,1.78-4.4,2.88-3.71,5.5-4.81,8.66-1.23,6.6-2.74,8.11-5.77,6.87-5.77,6.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.22,271S134,313,135.93,313.28,176.6,284.7,176.6,284.7L173,276.87l-25,9.34s-4.26-24.73-5.64-26.38-10.44-7.28-16.62-1.1",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamps--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.13,55.71l-6.68-9.55H165.3l-6.69,9.55a28.66,28.66,0,0,0,1,34.25l3.09,3.91H194l3.1-3.91A28.65,28.65,0,0,0,198.13,55.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.61,
    y1: 55.71,
    x2: 170.9,
    y2: 55.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.48,
    y1: 59.62,
    x2: 174.13,
    y2: 59.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.91,
    y1: 77.73,
    x2: 178.66,
    y2: 77.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.61,
    y1: 77.41,
    x2: 167.99,
    y2: 77.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.95,
    y1: 72.56,
    x2: 183.51,
    y2: 72.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.31,
    y1: 84.52,
    x2: 174.78,
    y2: 84.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.89,
    y1: 49.27,
    x2: 187.39,
    y2: 49.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.37,
    y1: 46.12,
    x2: 178.37,
    y2: 9.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.56,55.71l-6.68-9.55H244.73L238,55.71a28.66,28.66,0,0,0,1,34.25l3.09,3.91h31.28l3.1-3.91A28.66,28.66,0,0,0,277.56,55.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.04,
    y1: 55.71,
    x2: 250.33,
    y2: 55.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.91,
    y1: 59.62,
    x2: 253.56,
    y2: 59.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.34,
    y1: 77.73,
    x2: 258.09,
    y2: 77.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.04,
    y1: 77.41,
    x2: 247.42,
    y2: 77.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.38,
    y1: 72.56,
    x2: 262.94,
    y2: 72.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.74,
    y1: 84.52,
    x2: 254.21,
    y2: 84.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.32,
    y1: 49.27,
    x2: 266.82,
    y2: 49.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.8,
    y1: 46.12,
    x2: 257.8,
    y2: 9.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,55.71l-6.68-9.55H324.16l-6.69,9.55a28.66,28.66,0,0,0,1,34.25l3.09,3.91h31.28L356,90A28.66,28.66,0,0,0,357,55.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.47,
    y1: 55.71,
    x2: 329.76,
    y2: 55.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.34,
    y1: 59.62,
    x2: 332.99,
    y2: 59.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.77,
    y1: 77.73,
    x2: 337.52,
    y2: 77.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.47,
    y1: 77.41,
    x2: 326.85,
    y2: 77.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.8,
    y1: 72.56,
    x2: 342.37,
    y2: 72.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.17,
    y1: 84.52,
    x2: 333.64,
    y2: 84.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.75,
    y1: 49.27,
    x2: 346.25,
    y2: 49.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.23,
    y1: 46.12,
    x2: 337.23,
    y2: 9.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-30"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.31,
    y1: 475.12,
    x2: 488.8,
    y2: 475.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeshopBro);
export default __webpack_public_path__ + "static/media/Coffee shop-bro.ae7efea7093c5083f46a3ffc12bf3e97.svg";
export { ForwardRef as ReactComponent };